import Card from '../ui/Card';

/**
 * Live Response Counter Component
 * Simple response counter with participant tracking
 */

const LiveResponseCounter = ({
  totalParticipants = 0,
  responseCount = 0,
  activityType = 'activity',
  showDetails = true
}) => {
  const responsePercentage = totalParticipants > 0 ? (responseCount / totalParticipants) * 100 : 0;
  const participationRate = responsePercentage.toFixed(1);

  const getBarColor = () => {
    if (responsePercentage >= 80) return 'bg-green-500';
    if (responsePercentage >= 50) return 'bg-amber-500';
    return 'bg-primary-500';
  };

  return (
    <div className="space-y-4">
      {/* Main Counter */}
      <Card padding="md" className="border border-neutral-200">
        <div className="text-center">
          <p className="text-sm text-neutral-500 mb-2">Responses</p>

          {/* Counter */}
          <div className="inline-flex items-baseline justify-center gap-1 mb-3">
            <span
              className="text-4xl font-bold"
              style={{
                color: responsePercentage >= 80 ? '#10b981' : responsePercentage >= 50 ? '#f59e0b' : '#3b82f6',
              }}
            >
              {responseCount}
            </span>
            <span className="text-2xl text-neutral-400">/ {totalParticipants}</span>
          </div>

          {/* Progress Bar */}
          <div className="w-full bg-neutral-200 rounded-full h-2 mb-2 overflow-hidden">
            <div
              className={`h-2 rounded-full transition-all duration-300 ${getBarColor()}`}
              style={{ width: `${responsePercentage}%` }}
            />
          </div>

          {/* Percentage */}
          <p className="text-sm text-neutral-600">
            {participationRate}% participation
          </p>
        </div>
      </Card>

      {/* Detailed Breakdown */}
      {showDetails && (
        <div className="grid grid-cols-2 gap-3">
          {/* Responded */}
          <Card padding="sm" className="border border-neutral-200">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-neutral-500">Responded</p>
                <p className="text-lg font-bold text-green-600">{responseCount}</p>
              </div>
            </div>
          </Card>

          {/* Pending */}
          <Card padding="sm" className="border border-neutral-200">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-neutral-100 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-neutral-500">Pending</p>
                <p className="text-lg font-bold text-neutral-600">{totalParticipants - responseCount}</p>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default LiveResponseCounter;
